import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import { getSettings, updateSettings } from '../../services/admin';
import PageTitle from '../../Component/Comman/PageTitle';

const Settings = () => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            setLoading(true);
            const response = await getSettings();
            if (response.success) {
                setSettings(response.data || {});
            } else {
                throw new Error(response.message || 'Failed to fetch settings');
            }
            setError(null);
        } catch (error) {
            console.error('Error fetching settings:', error);
            setError('Failed to fetch settings');
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (field, value) => {
        setSettings(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            await updateSettings(settings);
            alert("Settings updated successfully");
            setIsEditing(false);
        } catch (error) {
            alert(error.message || "Failed to update settings");
        } finally {
            setLoading(false);
        }
    };

    if (loading && !settings) {
        return (
            <div className="container-xxl">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error && !settings) {
        return (
            <div className="container-xxl">
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div className="container-xxl">
            <PageTitle pagetitle="Global Settings" sidebutton={false} />
            
            <div className="container-fluid">
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-xl-6 col-xxl-6">
                            <Card className="h-auto mb-3 border-0 shadow-sm">
                                <Card.Header className="bg-white border-bottom">
                                    <Card.Title className="mb-0">Withdrawal Settings</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Min Withdrawal Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={settings?.minWithdrawalAmount || ''}
                                                    onChange={(e) => handleInputChange('minWithdrawalAmount', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Max Withdrawal Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={settings?.maxWithdrawalAmount || ''}
                                                    onChange={(e) => handleInputChange('maxWithdrawalAmount', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Withdrawal Fee (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={settings?.withdrawalFeePercentage || ''}
                                                    onChange={(e) => handleInputChange('withdrawalFeePercentage', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Fixed Withdrawal Fee</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={settings?.withdrawalFeeFixed || ''}
                                                    onChange={(e) => handleInputChange('withdrawalFeeFixed', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            <Card className="h-auto mb-3 border-0 shadow-sm">
                                <Card.Header className="bg-white border-bottom">
                                    <Card.Title className="mb-0">Deposit Settings</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Min Deposit Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={settings?.minDepositAmount || ''}
                                                    onChange={(e) => handleInputChange('minDepositAmount', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Max Deposit Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={settings?.maxDepositAmount || ''}
                                                    onChange={(e) => handleInputChange('maxDepositAmount', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Deposit Bonus (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={settings?.depositBonusPercentage || ''}
                                                    onChange={(e) => handleInputChange('depositBonusPercentage', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>

                        <div className="col-xl-6 col-xxl-6">
                            <Card className="h-auto mb-3 border-0 shadow-sm">
                                <Card.Header className="bg-white border-bottom">
                                    <Card.Title className="mb-0">Referral Settings</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Referral Bonus Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={settings?.referralBonusAmount || ''}
                                                    onChange={(e) => handleInputChange('referralBonusAmount', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Referral Bonus (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={settings?.referralBonusPercentage || ''}
                                                    onChange={(e) => handleInputChange('referralBonusPercentage', Number(e.target.value))}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            <Card className="h-auto mb-3 border-0 shadow-sm">
                                <Card.Header className="bg-white border-bottom">
                                    <Card.Title className="mb-0">App Settings</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Min Android Version</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={settings?.minimumAndroidVersion || ''}
                                                    onChange={(e) => handleInputChange('minimumAndroidVersion', e.target.value)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Min iOS Version</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={settings?.minimumIosVersion || ''}
                                                    onChange={(e) => handleInputChange('minimumIosVersion', e.target.value)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Latest Android Version</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={settings?.latestAndroidVersion || ''}
                                                    onChange={(e) => handleInputChange('latestAndroidVersion', e.target.value)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Latest iOS Version</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={settings?.latestIosVersion || ''}
                                                    onChange={(e) => handleInputChange('latestIosVersion', e.target.value)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            <Card className="h-auto mb-3 border-0 shadow-sm">
                                <Card.Header className="bg-white border-bottom">
                                    <Card.Title className="mb-0">Support Settings</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Support Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    value={settings?.supportEmail || ''}
                                                    onChange={(e) => handleInputChange('supportEmail', e.target.value)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Support Phone</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={settings?.supportPhone || ''}
                                                    onChange={(e) => handleInputChange('supportPhone', e.target.value)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>

                        <div className="col-xl-12">
                            <Card className="h-auto mb-3 border-0 shadow-sm">
                                <Card.Header className="bg-white border-bottom">
                                    <Card.Title className="mb-0">System Settings</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    id="maintenanceMode"
                                                    label="Maintenance Mode"
                                                    checked={settings?.maintenanceMode || false}
                                                    onChange={(e) => handleInputChange('maintenanceMode', e.target.checked)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    id="registrationEnabled"
                                                    label="Enable Registration"
                                                    checked={settings?.registrationEnabled || false}
                                                    onChange={(e) => handleInputChange('registrationEnabled', e.target.checked)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    id="withdrawalsEnabled"
                                                    label="Enable Withdrawals"
                                                    checked={settings?.withdrawalsEnabled || false}
                                                    onChange={(e) => handleInputChange('withdrawalsEnabled', e.target.checked)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    id="depositsEnabled"
                                                    label="Enable Deposits"
                                                    checked={settings?.depositsEnabled || false}
                                                    onChange={(e) => handleInputChange('depositsEnabled', e.target.checked)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="g-3 mt-2">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    id="enableEmailNotifications"
                                                    label="Enable Email Notifications"
                                                    checked={settings?.enableEmailNotifications || false}
                                                    onChange={(e) => handleInputChange('enableEmailNotifications', e.target.checked)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    id="enableSMSNotifications"
                                                    label="Enable SMS Notifications"
                                                    checked={settings?.enableSMSNotifications || false}
                                                    onChange={(e) => handleInputChange('enableSMSNotifications', e.target.checked)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    id="enablePushNotifications"
                                                    label="Enable Push Notifications"
                                                    checked={settings?.enablePushNotifications || false}
                                                    onChange={(e) => handleInputChange('enablePushNotifications', e.target.checked)}
                                                    disabled={!isEditing}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <div className="d-flex justify-content-end gap-2">
                                {!isEditing ? (
                                    <Button variant="primary" className="btn-rounded" onClick={() => setIsEditing(true)}>
                                        <i className="fa fa-edit me-2"></i>Edit Settings
                                    </Button>
                                ) : (
                                    <>
                                        <Button 
                                            variant="secondary" 
                                            className="btn-rounded"
                                            onClick={() => {
                                                setIsEditing(false);
                                                fetchSettings();
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button 
                                            variant="primary" 
                                            type="submit" 
                                            disabled={loading}
                                            className="btn-rounded"
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Saving...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa fa-save me-2"></i>Save Changes
                                                </>
                                            )}
                                        </Button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default Settings;
